import Vue from 'vue';

export function lunchData (params) {
  return Vue.axios({
    url: '/api/child/lunch',
    method: 'get',
    params: params
  })
}
